import axios from 'axios';

export const credentialsSupportWorkflow = (credentials, workflow) => (
  Array.isArray(credentials)
  && credentials.some((credential) => (
    Array.isArray(credential.supports_workflows)
    && credential.supports_workflows.includes(workflow)
  ))
);

export const fetchStandaloneTaskSupport = async () => {
  try {
    const response = await axios.get('/api/v1/emr_integration_credentials');
    return credentialsSupportWorkflow(response.data.credentials, 'task_creation');
  } catch (error) {
    console.error('Failed to fetch EMR credential capabilities', error);
    return false;
  }
};

export const canUseStandaloneTask = ({
  hasEmrIntegrationCredential,
  credentialSupportsStandaloneTask,
  autoUploadEmr,
}) => {
  if (hasEmrIntegrationCredential && autoUploadEmr !== 'CareCloud') {
    return credentialSupportsStandaloneTask;
  }

  return autoUploadEmr !== 'AdvancedMD';
};

// CareCloud is being moved to three-layer incrementally. Until its adapter can
// execute uploads, keep the existing uploader available alongside the new
// patient-search drawer for organizations that have both credential types.
export const shouldUseLegacyEmrActions = ({
  hasEmrIntegrationCredential,
  autoUploadEmr,
}) => !hasEmrIntegrationCredential || autoUploadEmr === 'CareCloud';
